module.exports = __webpack_public_path__ + "img/scp-bg.83fa2057.png";